import { IconFileClock } from '@iwoca/icons';
import { Button } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';

import StepItem from '../../stepItem/StepItem';

export const PendingAccount = () => {
    return (
        <StepItem
            title={
                <FormattedMessage
                    id="_.funding_requirements.pending_bank_details_title"
                    defaultMessage="Your business bank details"
                />
            }
            caption={
                <FormattedMessage
                    id="_.funding_requirements.pending_bank_details.bank_details_received"
                    defaultMessage="We have received your bank details. Please wait until we have verified your bank details and marked this step as ‘Complete’."
                />
            }
            action={
                <Button
                    variant="primary"
                    disabled
                    className="min-w-[124px]"
                    data-testid="pending-bank-details-button"
                >
                    <IconFileClock />
                </Button>
            }
        />
    );
};
